





































































































































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Title from '../../components/Title.vue';
import {
  ConfigListParams,
  ConfigListData,
  ConfigListRes, 
  ConfigListTable, 
  Users, 
  Stores,
  StoreGroup,
  GeneralUserListRes,
  GeneralUserListData,
  GenerateData,
  FormDetail,
  commonRes,
} from '@/store/pages/config/index.d';
const Config = namespace('config');
@Component({
  components: {
    Title,
  },
})
export default class Index extends Vue {
  @Config.Getter('configList') private configList!: ConfigListData;
  @Config.Getter('generalUserList') private generalUserList!: GeneralUserListData[];
  @Config.Action('getConfigList') private getConfigList: any;
  @Config.Action('getGeneralUserList') private getGeneralUserList: any;
  @Config.Action('changeStatus') private changeStatus: any;
  @Config.Action('settingChecker') private settingChecker: any;
  private title: string[] = ['配置管理'];
  private dialogTableVisible: boolean = false;
  private dialogDetaileTableVisible: boolean = false;
  private dialogCheckerTableVisible: boolean = false;
  private confirmStyle: boolean = false;
  private loading: boolean = true;
  private allData: GenerateData[] = [];
  private selectedData: number[] = [];
  private labelPosition: string = 'right';
  private reportName: string = '业务数据日报';
  private tips: string = '';
  private status: number = 0;
  private report_id: number = 0;
  private operate: string[] = ['禁用', '启用'];

  private formDetail: FormDetail = {
    name: '奔驰华南区日报',
    report_id: 1,
    report_type: '二手车业务',
    template: '业务数据日报',
    status: '1',
    statistic_range: [],
    checker: [],
  };
  private requestParams: ConfigListParams = {
    page: 1,
    count: 10,
    sort_order: 0,
  };
  public filterMethod(query: string, item: GenerateData) {
    return item.name.indexOf(query) > -1 || item.mobile_number.indexOf(query) > -1 || item.belong_store.indexOf(query) > -1 || item.lowercaseName.indexOf(query) > -1;
  }
  public mounted() {
    this.getData();
    this.getGeneralUserList().then((res: GeneralUserListRes) => {
      this.generateData();
    });
  }
  public getData() {
    this.loading = true;
    this.getConfigList(this.requestParams).then((res: ConfigListRes) => {
      this.loading = false;
    });
  }
  public handleSizeChange(val: number) {
    this.requestParams.count = val;
    this.requestParams.page = 1;
    this.getData();
  };
  public handleCurrentChange(val: number) {
    this.requestParams.page = val;
    this.getData();
  }
  public go(path: string, row: any) {
    const {status, statistic_range, report_id} = row;
    this.$router.push({
      path,
      query: {
        report_id,
      },
    });
  }
  public goBlank(path: string) {
    const {href} = this.$router.resolve({
      path,
    })
    window.open(href, '_blank')
  }
  public operateChange(row: ConfigListTable) {
    this.dialogTableVisible = true;
    const{ report_id, status } = row;
    const newStatus = status === 1 ? 2 : 1;
    this.tips = status === 1 ? '禁用后，系统依然采集数据且历史数据会被保留，但用户不可查看报表。是否禁用？' : '启用后，具有查看报表的用户可以查看报表。是否启用?'
    this.confirmStyle = status === 2 ? true : false;
    this.report_id = report_id;
    this.status = newStatus;
  }
  public statusConfirm() {
    this.dialogTableVisible = false;
    this.changeStatus({reportId: this.report_id, status: this.status}).then((res: commonRes) => {
      this.getConfigList(this.requestParams);
    });
  }
  public check(id: number) {
    this.selectedData = [];
    this.report_id = id;
    this.configList.table.forEach((item: ConfigListTable) => {
      if (item.report_id === id) {
        item.users.forEach((user: Users) => {
          this.selectedData.push(user.user_id);
          this.reportName = item.name
        })
      }
    })
    this.dialogCheckerTableVisible = true;
    if (this.$refs.checkTransfer) {
      const transfers: any = this.$refs.checkTransfer;
      transfers.clearQuery('right');
      transfers.clearQuery('left');
    }
  }
  public saveChecker() {
    this.dialogCheckerTableVisible = false;
    this.settingChecker({
      reportId: this.report_id, 
      viewers: this.selectedData
      }).then((res: commonRes) => {
        this.getData();
      });
  }
  public showDetail(id: number) {
    this.formDetail.checker = [];
    this.formDetail.statistic_range = [];
    this.configList.table.forEach((item: ConfigListTable) => {
      this.dialogDetaileTableVisible = true;
      if (item.report_id === id) {
        const {name, report_id, report_type, template, status, statistic_range, stores, store_groups, users} = item;
        this.formDetail.name = name;
        this.formDetail.report_id = report_id;
        this.formDetail.report_type = report_type;
        this.formDetail.template = template;
        this.formDetail.status = status - 1 ? '已停用' : '使用中';
        if (statistic_range === 1) {
          store_groups.forEach((group: StoreGroup) => {
            this.formDetail.statistic_range.push(group.name);
          }) 
        } else {
          stores.forEach((store: Stores) => {
            this.formDetail.statistic_range.push(store.name);
          }) 
        }
        users.forEach((user: any) => {
          let checkerString: string = `${user.name}\xa0\xa0\xa0\xa0\xa0${user.mobile_number}\xa0\xa0\xa0\xa0\xa0${user.belong_store}`;
          this.formDetail.checker.push(checkerString);
        })
      }
    })
  }
  public sortChange(params: any) {
    const {order} = params;
    this.requestParams.sort_order = order === 'ascending' ? 1 : 0;
    this.getData();
  }
  public generateData() {
    this.generalUserList.forEach((item: GeneralUserListData, index: number, arr: GeneralUserListData[]) => {
      let json: GenerateData = {
        label: `${item.name}\xa0\xa0\xa0\xa0\xa0${item.mobile_number}\xa0\xa0\xa0\xa0\xa0${item.belong_store}`,
        key: item.user_id,
        name: item.name,
        lowercaseName: item.name.toLocaleLowerCase(),
        mobile_number: item.mobile_number,
        belong_store: item.belong_store,
      };
      this.allData.push(json);
    })
  }
}
